import { render, staticRenderFns } from "./LetterStepBank.vue?vue&type=template&id=31efe0fd&scoped=true&"
import script from "./LetterStepBank.vue?vue&type=script&lang=ts&"
export * from "./LetterStepBank.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31efe0fd",
  null
  
)

export default component.exports